import { types } from "../types";

const LoginAction = {
  userLoginAuth: (credentials) => {    
    return { type: types.USERLOGIN_AUTH, credentials };
  },
  userLoginAuthSuccess: (user) => {
    return { type: types.USERLOGIN_AUTH_SUCCESS, user };
  },
  userCurrentMenu: (menuCode) => {
    return { type: types.USER_CURRENT_MENU, menuCode };
  }
};

export default LoginAction;
